var handlingUserDataLink = "https://www.gonicus.de/documents/ds-bewerberdaten.pdf";
var mail_recipient = "jobs@gonicus.de"
export { handlingUserDataLink, mail_recipient }